define([
    'jquery',
    'mainGtm',
    'weborama',
    'pageLoader',
    'popup',
    'formElements',
    'matchSize',
    'globalVars',
    'mage/validation',
    'mage/translate',
], (
    $,
    mainGtm,
    weborama,
    pageLoader,
    popup,
    formElements,
    matchSize,
    { $body },
    $t
) => {
    return {
        settings: {
            $newsletterPopup: $('#popupFeedback'),
            $form: $('#feedbackForm'),
            options: {
                title: '',
                modalClass: 'feedback_popup__modal',
                frameName: '#popupFeedback',
                subscribeForm: '#feedbackForm',
                email: '#feedbackEmail',
                description: '#feedbackDescription',
                consentToDataProcessing: '#feedbackAccept',
                gtmReferral: 'feedback',
            },
            source: '',
        },

        init() {
            this.initCache();
            this.initEvents();
            this.validateForm();
        },

        initCache() {
            this.$repeatBtn = $('.js-popup-feedback-repeat-button');
        },

        initEvents() {
            $body.on('click', '.js-chat-icons-main', this.openPopup.bind(this));
            this.$repeatBtn.on('click', this.showContent.bind(this));
        },

        openPopup(event) {
            event.preventDefault();

            const $target = $(event.currentTarget);

            $('.js-popup-feedback-content').show();
            $('.js-answer-feedback-text').hide();
            $('.js-popup-feedback-repeat-button').hide();

            // eslint-disable-next-line one-var
            const gtmReferral = $target.data('gtm-referral');

            if (gtmReferral !== '') {
                this.settings.options.gtmReferral = gtmReferral;
            }

            popup(this.settings.options);

            this.settings.source = $target.closest('.header').length
                ? 'LpHeaderSubscribe'
                : 'LpFooterSubscribe';
        },

        validateForm() {
            const { $form } = this.settings;

            $form.mage('validation', {
                errorClass: 'mage-error',
                submitHandler: () => {
                    this.sendFormData($form);
                },
            });
        },

        sendFormData($form) {
            $.ajax({
                type: 'post',
                contentType: 'application/json',
                url: `${$form.attr('action')}/${$form
                    .find('[name="email"]')
                    .val()}/${$form.find('[name="description"]').val()}`,
                beforeSend() {
                    pageLoader.showLoading();
                },
                complete() {
                    pageLoader.hideLoading();
                    $form.addClass('_send');
                },
                error: () => {
                    this.showResponse(
                        'Извините, произошла ошибка, Ваше обращение не было отправлено. Повторите, пожалуйста, попытку'
                    );
                    $('.js-popup-feedback-repeat-button').show();
                },
                success: data => {
                    if (data) {
                        if (data === '200') {
                            this.showResponse(
                                'Спасибо за обращение, мы свяжемся с вами по указанной электронной почте'
                            );
                        } else {
                            this.showResponse(
                                'Извините, произошла ошибка, Ваше обращение не было отправлено. Повторите, пожалуйста, попытку'
                            );
                            $('.js-popup-feedback-repeat-button').show();
                        }
                        this.clearForm();
                        // weborama.pushSubscribtion(
                        //     $form.find('[name="email"]').val()
                        // );
                        // mainGtm.pushSubscription(
                        //     this.settings.options.gtmReferral
                        // );
                    }
                },
            });
        },

        showResponse(text) {
            $('.js-popup-feedback-content').hide();
            $('.js-answer-feedback-text').text(text).show();
        },

        showContent() {
            $('.js-popup-feedback-content').show();
            $('.js-answer-feedback-text').hide();
            $('.js-popup-feedback-repeat-button').hide();
        },

        clearForm() {
            $(
                `${this.settings.options.email}, ${this.settings.options.description}`
            ).val('');
            $(`${this.settings.options.description}`).removeClass(
                'js-counter-inited'
            );
            formElements.init();
        },
    };
});
